export interface AppSearchDataProps {
  searchText?: string;
}
export interface AppSearchHistoryPreference {
  searchTerms: AppSearchItem[];
}

export enum AppSearchItemType {
  View = 'VIEW',
  Action = 'ACTION',
}

export interface AppSearchItem {
  label?: string;
  name: string;
  description?: string;
  link: string;
  icon?: React.ReactElement | AppSearchIconKey;
  type?: AppSearchItemType;
}

export enum AppSearchIconKey {
  Event = 'EVENT',
  Cloud = 'CLOUD',
  Gate = 'GATE',
  Sign = 'SIGN',
  Video = 'VIDEO',
  Signal = 'SIGNAL',
  Tunnel = 'TUNNEL',
  Corridor = 'CORRIDOR',
  Counts = 'COUNT',
  RampMeter = 'RAMP_METER',
  TravelTime = 'TRAVEL_TIME',
  TollingPoint = 'TOLLING_POINT',
  AssetManagement = 'ASSET_MANAGEMENT',
  ConnectedVehicle = 'CONNECTED_VEHICLE',
  Incident = 'INCIDENT',
  PlannedEvent = 'PLANNED_EVENT',
  RoadCondition = 'ROAD_CONDITION',
  Weather = 'WEATHER',
  Parking = 'PARKING',
}
